module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNy44MjMiIGhlaWdodD0iMjIuNDIiIHZpZXdCb3g9IjAgMCAxNy44MjMgMjIuNDIiPjxwYXRoIGZpbGw9IiNGQzhCNjAiIGQ9Ik0xNi4yMjMgMTIuNDkzTDMuNzg2IDIxLjNhMS41MTcgMS41MTcgMCAwIDEtMS4wNzguNDQ3IDEuNTAzIDEuNTAzIDAgMCAxLS41ODgtLjExNiAxLjUzMyAxLjUzMyAwIDAgMS0uOTQxLTEuNDFWMi42MWExLjUyOSAxLjUyOSAwIDAgMSAuOTQxLTEuNDEyIDEuNTIgMS41MiAwIDAgMSAxLjY2Ni4zMzFsMTIuNDM5IDguODA2Yy4yODMuMjg0LjQ0NS42NzguNDQ1IDEuMDggMCAuMzk5LS4xNjIuNzkzLS40NDcgMS4wNzh6Ii8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./public/img/headerIcons/player-play.svg
// module id = 106
// module chunks = 0